import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { BankNotification } from '@features/banking/types'

import { bankNotificationsQueryKey } from '../queries/useBankNotificationsTable'

/** Znova rozparsuje uloženú správu. Má zmysel po doplnení nového typu
 * notifikácie — surové HTML je uložené, netreba ho ťahať z Gmailu. */
export function useReparseNotification() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string): Promise<BankNotification> => {
      const res = await apiClient.post<BankNotification>(
        `${BACK_OFFICE_PREFIX}bank-notifications/${id}/reparse`
      )
      return res.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bankNotificationsQueryKey })
    }
  })
}
